export const paths = {
  basename: "/",
  HomePage: "/HomePage",
  ResultSearchPage: "/ResultSearchPage",
  TicketPage: "/TicketPage", 
  Login: "/Login",
  RecuperarPassword: "/Recuperacion",
  UnificarCURPS: "/Unificar"
};